"use client";

import { RoomCard } from '@/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/components/rooms/RoomCard';
import RoomsLoading from '@/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/components/rooms/RoomsLoading';
import HotelBoxV2 from '@/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/HotelBoxV2';
import NavigateToSearchPage from '@/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/NewComponents/NavigateToSearchPage';
import useHotelDetailStore from '@/core/stores/hotelDetail';
import { useRoomsStore } from '@/core/stores/rooms';
import { useUserStore } from '@/core/stores/user';
import useWebbedStore from '@/core/stores/webbed';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import useSizeController from '@/hooks/useSizeController';
import { NewWebbedRoomDetails, WebbedHotel } from '@/types/webbeds';
import { calculateDateDistance } from '@/utils/dateOperators/calculateDateDistance';
import { deCodeOccupancies } from '@/utils/deCodeOccupancies';
import getNextDate from '@/utils/getNextDay';
import { slugifyOptions } from '@/utils/slugifyOptions';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Cookies from 'js-cookie';
import dynamic from 'next/dynamic';
import Image from "next/image";
import { usePathname } from 'next/navigation';
import { useEffect, useState } from "react";
import slugify from 'slugify';
import NextLink from '../../../../../../../../../../components/NextLink';
import Button from '@/components/ui/Button';

const RoomDetailsModal = dynamic(() => import('@/app/(pages)/(hotelDetail)/hotel/[country]/[city]/[hotelName]/(main)/components/rooms/RoomDetail'), { ssr: false });

export default function Rooms({ hotelDetails, hotelCode, city, hotelName, wpUrl }: { wpUrl: string; hotelDetails: WebbedHotel; hotelCode: string; city?: string; hotelName?: string }) {

  const pathname = usePathname();
  const { setHotelData, setHotelCode, resetSelectedRoom, } = useWebbedStore();

  useEffect(() => {
    resetSelectedRoom()
    setHotelCode(hotelCode)
    setHotelData(hotelDetails)
  }, [hotelCode])

  const [homeDetailsOfAvailibilty, setHomeDetailsOfAvailibilty] = useState<{

    rooms: NewWebbedRoomDetails[][]
  } | null>(null);

  const [showAll, setShowAll] = useState(false);

  const { checkIn, checkOut, passenger, setCheckIn, setPolicies, setTotalPrice, setCheckOut,
    setPassenger, isGetting, setIsGetting, setAvailableRooms, setMinPrice } = useHotelDetailStore()

  const { isSmall } = useSizeController()

  const { params: { checkIn: checkinParam = getNextDate(0), checkOut: checkOutParam = getNextDate(1),
    passenger: passengerParam = 'a1-c-1', lat, lng, residence: residenceParam }, setSearchParam, getSearchParamsString }
    = useSetSearchParams();

  // useEffect(() => {
  //   if (checkOutParam && checkinParam && passengerParam) {
  //     setCheckIn(checkinParam)
  //     setCheckOut(checkOutParam)
  //     setPassenger(passengerParam)
  //   }
  // }, [checkOutParam, checkinParam, passengerParam])

  const stayDuration = calculateDateDistance(checkIn, checkOut)
  const currency = Cookies.get('currency') || 'USD'
  const duration = calculateDateDistance(checkIn, checkOut)

  const fetchAvailibilty = async () => {
    setIsGetting(true)
    const body = {
      code: hotelCode.toString(),
      checkIn: checkinParam,
      checkOut: checkOutParam,
      passenger: passengerParam,

      filter: {
        price: {
          minRate: 0,
          maxRate: 100000,
        },
      }
    }
    try {
      const res = await fetch(`/api/hotels/webbedHotel`, {
        method: 'POST',
        body: JSON.stringify(body)
      })
      const result = (await res.json()).result;
      if (result) {
        resetSelectedRoom()
        setHomeDetailsOfAvailibilty(result);
        setPolicies(result.rooms[0][0]?.rateBases[0]?.tariffNotes)
        setTotalPrice({ currency: currency, price: result.rooms[0][0]?.rateBases[0].price })
        setIsGetting(false)
      } else {
        setIsGetting(false)
        setTotalPrice({ currency: currency, price: '' })
        setHomeDetailsOfAvailibilty({ rooms: [] });
      }
    } catch (err) {
      setIsGetting(false)
    }
  }

  useEffect(() => {
    if (checkOutParam && checkinParam && passengerParam) {
      fetchAvailibilty();
    }
  }, [checkOutParam, checkinParam, passengerParam]);

  const { addActions, } = useUserStore()

  useEffect(() => {
    if (homeDetailsOfAvailibilty?.rooms) {
      setAvailableRooms(homeDetailsOfAvailibilty?.rooms.length)
      if (homeDetailsOfAvailibilty.rooms[0]) {
        setMinPrice(Number(homeDetailsOfAvailibilty.rooms[0][0].minPrice))
      }
    }
  }, [homeDetailsOfAvailibilty, setAvailableRooms, setMinPrice])

  const decodedPassenger = deCodeOccupancies(passengerParam)?.map(
    (room) => {
      const occupancy: any = {
        rooms: 1,
        adults: room.adults,
        children: room.children.length,
      };
      if (room.children.length) {
        occupancy.childrenAge = room.children;
      }
      return occupancy;
    },
  );

  const totalPassenger = decodedPassenger.map(item => item.adults + item.children)

  const minMaxChildrenAges = decodedPassenger.map((room) =>
    room.childrenAge?.length ? [Math.max(...room.childrenAge), Math.min(...room.childrenAge)] : []
  );

  const [activeRoomDetail, setActiveRoomDetail] = useState<{
    mainRoomIndex: number;
    roomIndex: number;
  } | null>(null)

  return (
    <>
      {homeDetailsOfAvailibilty && activeRoomDetail &&
        homeDetailsOfAvailibilty.rooms[activeRoomDetail.mainRoomIndex][activeRoomDetail.roomIndex]
        && <RoomDetailsModal
          country={hotelDetails.country}
          roomIndex={activeRoomDetail.mainRoomIndex}
          hotelRate={hotelDetails.stars}
          city={city!}
          hotelCode={hotelCode}
          hotelName={hotelDetails?.name}
          room={homeDetailsOfAvailibilty.rooms[activeRoomDetail.mainRoomIndex][activeRoomDetail.roomIndex]}
          currency={currency}
          show={!!activeRoomDetail}
          onClose={() => setActiveRoomDetail(null)}
          roomDetails={{}}
        />}
      {homeDetailsOfAvailibilty ? !isGetting ? (homeDetailsOfAvailibilty?.rooms.length > 0 ?
        homeDetailsOfAvailibilty.rooms.map((roomsArray, index) => {
          const roomIndex = index
          return <HotelBoxV2 key={roomIndex} className='md:mt-3 first:md:mt-0 md:border-2 md:!border-t-2 border-gray-200'>
            <div className="">
              <div className='w-full pb-4'>
                <h2 className=' text-neutral-800 flex items-center w-full justify-between gap-2'>
                  <span>

                    Room {index + 1}
                  </span>
                  {roomsArray &&
                    <p className='text-xs text-secondary-500 font-medium'>
                      {roomsArray.length} Rooms
                    </p>
                  }
                </h2>
                <p className='flex items-center gap-2 mt-2'>
                  <FontAwesomeIcon icon={faUser} className='text-gray-500 text-xs' />
                  {decodedPassenger[roomIndex]?.adults && <span className='text-xs font-normal text-gray-700'> {decodedPassenger[roomIndex]?.adults} Adult(s)
                    {decodedPassenger[roomIndex]?.children ? ` and 
                  ${decodedPassenger[roomIndex]?.children} ${decodedPassenger[roomIndex]?.children > 1 ? 'children' : 'child'}` : ''}
                  </span>}
                </p>
              </div>

              {roomsArray ? <div className="grid grid-flow-row grid-cols-4 gap-2 ">
                {!isGetting ? (
                  roomsArray?.length ? (
                    roomsArray
                      ?.slice(0, pathname.includes(`/rooms`) || showAll ? roomsArray?.length : !isSmall ? 4 : 3)
                      .map((room: NewWebbedRoomDetails, index: number) => {

                        return (!room.minStay || (room.minStay && (stayDuration > Number(room.minStay)))) && (
                          <RoomCard
                            minMaxChildrenAges={minMaxChildrenAges[roomIndex]}
                            totalPassenger={totalPassenger[roomIndex]}
                            setActiveRoomDetail={setActiveRoomDetail}
                            key={index}
                            mainRoomIndex={roomIndex}
                            roomIndex={index}
                            room={room}
                            duration={duration}
                          />
                        );
                      })
                  ) : (
                    <div className="col-span-full gap-2 grid px-6 md:px-16 py-6 md:grid-cols-[180px,_1fr] rounded-lg bg-white p-4">
                      <Image
                        className=" mx-auto w-36 mb-2 md:mb-0 md:w-11/12"
                        src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/8e3e88e2-5fb5-4fa2-bf0c-6e26a2590572.png`}
                        width={300}
                        height={300}
                        quality={65}
                        alt="Nothing Found"
                      />
                      <div className='flex flex-col gap-2 justify-between'>

                        <p className=" text-xl font-bold">
                          Bummer, No Luck!
                        </p>
                        <p className='text-neutral-500 text-sm'>Someone got to your room first!
                          How about choosing another time or spot?</p>
                        <div className='flex gap-2 mt-2 md:mt-0 flex-wrap md:gap-4'>
                          <NavigateToSearchPage
                            lat={lat}
                            lng={lng}
                            checkIn={checkIn}
                            checkOut={checkOut}
                            passenger={passenger}
                            country={slugify(hotelDetails.country, slugifyOptions)}
                            city={city as string}
                            className='bg-secondary-500-900 w-full md:w-fit text-center text-sm text-white rounded-full px-3
                                 md:px-5 py-2.5'
                          >
                            Explore Hotels
                          </NavigateToSearchPage>

                          <button
                            onClick={() => setSearchParam([{ checkIn: getNextDate(7) }, { checkOut: getNextDate(8) }, { passenger: 'a1_c-1' }])}
                            className='border-2 w-full md:w-fit border-neutral-900 text-sm text-neutral-900 rounded-xl  px-3 md:px-5 py-2.5'>Update Search</button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <RoomsLoading />
                )}
              </div> : <RoomsLoading />}
              {((isSmall && roomsArray?.length > 3) ||
                (!isSmall && roomsArray?.length > 4)

              ) && !pathname.includes(`/rooms`) && (<>
                <NextLink onClick={() => {
                  addActions({ type: 'click', message: 'opened more rooms page' })
                }}
                  href={`/hotel/${slugify(hotelDetails.country)}/${city}/${slugify(hotelDetails.name)}/rooms?${getSearchParamsString()}`}
                  className='text-secondary-500 text-xs flex py-2 lg:hidden items-center gap-2'>
                  See all room
                  <FontAwesomeIcon icon={faChevronRight} />
                </NextLink>
                <button onClick={() => {
                  addActions({ type: 'click', message: 'opened more rooms page' })
                  setShowAll(s => !s)
                }}
                  className='text-secondary-500 text-xs hidden lg:flex py-2 items-center gap-2 '>
                  {showAll ? `Show less` : `See all room`}
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </>)}
            </div>
          </HotelBoxV2>
        }) : <HotelBoxV2 className=''>
          <div className="col-span-full gap-2 grid px-6 md:px-16 py-6 md:grid-cols-[180px,_1fr] rounded-lg bg-white p-4">
            <Image
              className=" mx-auto w-36 mb-2 md:mb-0 md:w-11/12"
              src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/8e3e88e2-5fb5-4fa2-bf0c-6e26a2590572.png`}
              width={300}
              height={300}
              quality={65}
              alt="Nothing Found"
            />
            <div className='flex flex-col gap-2 justify-between'>

              <p className=" text-xl font-bold">
                Bummer, No Luck!
              </p>
              <p className='text-neutral-500 text-sm'>Someone got to your room first!
                How about choosing another time or spot?</p>
              <div className='flex gap-2 mt-2 md:mt-0 flex-wrap md:gap-4'>
                <NavigateToSearchPage
                  lat={lat}
                  lng={lng}
                  checkIn={checkIn}
                  checkOut={checkOut}
                  passenger={passenger}
                  city={city as string}
                  className='w-full md:w-fit'
                >
                  <Button
                    color='secondary'
                    radius='rounded-full'
                    className='w-full md:w-fit'
                  >

                    Explore Hotels
                  </Button>
                </NavigateToSearchPage>

                <Button
                  color='ghost'
                  radius='rounded-full'
                  onClick={() => setSearchParam([{ checkIn: getNextDate(7) }, { checkOut: getNextDate(8) }, { passenger: 'a1_c-1' }])}
                  className='w-full md:w-fit'>Update Search</Button>
              </div>
            </div>
          </div>
        </HotelBoxV2>) : <HotelBoxV2 className=''>
        <RoomsLoading />
      </HotelBoxV2> :
        <HotelBoxV2 className=''>
          <RoomsLoading />
        </HotelBoxV2>}
    </>
  );

}
